import { useMemo } from "react";
import { useAppDispatch, useRootState } from "./index";
import { bindActionCreators } from "redux";
import {
  trunkGetPositionList,
  trunkInsertPosition,
  trunkUpdatePosition,
  trunkDeletePosition,
  trunkGetRoleList,
  trunkInsertRole,
  trunkUpdateRole,
  trunkDeleteRole,
} from "../store/admin/adminPositionRole";

const useAdminPositionRoleStore = () => {
  const positionRoleState = useRootState(
    (state) => state.adminPositionRoleStore
  );

  const dispatch = useAppDispatch();

  const boundGetPositionList = useMemo(
    () => bindActionCreators(trunkGetPositionList, dispatch),
    [dispatch]
  );
  const boundInsertPosition = useMemo(
    () => bindActionCreators(trunkInsertPosition, dispatch),
    [dispatch]
  );
  const boundUpdatePosition = useMemo(
    () => bindActionCreators(trunkUpdatePosition, dispatch),
    [dispatch]
  );
  const boundDeletePosition = useMemo(
    () => bindActionCreators(trunkDeletePosition, dispatch),
    [dispatch]
  );
  const boundGetRoleList = useMemo(
    () => bindActionCreators(trunkGetRoleList, dispatch),
    [dispatch]
  );
  const boundInsertRole = useMemo(
    () => bindActionCreators(trunkInsertRole, dispatch),
    [dispatch]
  );
  const boundUpdateRole = useMemo(
    () => bindActionCreators(trunkUpdateRole, dispatch),
    [dispatch]
  );
  const boundDeleteRole = useMemo(
    () => bindActionCreators(trunkDeleteRole, dispatch),
    [dispatch]
  );

  return {
    positionRoleState,
    getPositionList: boundGetPositionList,
    insertPosition: boundInsertPosition,
    updatePosition: boundUpdatePosition,
    deletePosition: boundDeletePosition,
    getRoleList: boundGetRoleList,
    insertRole: boundInsertRole,
    updateRole: boundUpdateRole,
    deleteRole: boundDeleteRole,
  };
};

export default useAdminPositionRoleStore;
